import Vue from 'vue'
import store from './store'
import './plugins/bootstrap-vue'
import './assets/main.scss'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import messages from './lang'
import cognito from './cognito'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import "./vee-validate";
import Zendesk from '@dansmaculotte/vue-zendesk'
import sanitizeHTML from 'sanitize-html'
import VueScrollTo from 'vue-scrollto'
import gv from '@/mixins/globalValiables'
import * as VueGoogleMaps from 'vue2-google-maps'
import Geocoder from "@pderas/vue2-geocoder";
import LoadScript from 'vue-plugin-load-script';
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import router from './router'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faEyeSlash, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueYoutube from 'vue-youtube'
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)
Vue.use(BootstrapVueIcons)

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

export default function vueScrollTo (context, inject) {
  inject('scrollTo', vueScrollTo.scrollTo)
}
Vue.use(sanitizeHTML);
Vue.use(VueScrollTo)
Vue.use(VueYoutube)

import './plugins/axios';
// Vue.use(AxiosPlugin)

Vue.use(Zendesk, {
  key: '009d7ce8-554b-4ef7-b395-e15724a1bd5a',
  disabled: true,
  hideOnLoad: true,
  settings: {
    webWidget: {
      color: {
        theme: '#78a300'
      }
    }
  }
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBnEN9-Rp76SMz5sj9D1EHlWmPqwEtj-xw',
    libraries: 'places'
  }
})


Vue.use(Geocoder, {
    defaultCountryCode: null, // e.g. 'CA'
    defaultLanguage:    'ja', // e.g. 'en'
    defaultMode:        'address', // or 'lat-lng'
    googleMapsApiKey:   'AIzaSyBnEN9-Rp76SMz5sj9D1EHlWmPqwEtj-xw'
});

Vue.prototype.$sanitize = sanitizeHTML



awsconfig.aws_user_pools_id = process.env.VUE_APP_AWS_POOLS_ID
awsconfig.aws_user_pools_web_client_id = process.env.VUE_APP_AWS_WEB_CLIENT_ID
awsconfig.oauth.domain = process.env.VUE_APP_AWS_DOMAIN
awsconfig.oauth.redirectSignIn = process.env.VUE_APP_AWS_REDIRECT_URL
awsconfig.oauth.redirectSignOut = process.env.VUE_APP_AWS_REDIRECT_URL
awsconfig.oauth.responseType = process.env.VUE_APP_AWS_RESPONSETYPE
Amplify.configure(awsconfig)

Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(LoadScript);
Vue.mixin(gv)


library.add(faEye, faEyeSlash, faSearch)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueSweetalert2);
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja',
  messages,
})

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.config.productionTip = false
Vue.loadScript("https://www.paypal.com/sdk/js?client-id=AdxI0i-euVBX9ZgJ2TLejuQyHoGReuB7DBtS43IlI7fhXt4GKr_9P6jyBf4uAVHQsUvgQ_zG8bPTaxA6&vault=true")

new Vue({
  router,
  i18n,
  cognito,
  store,
  created() {},
  methods: {
    handleClick_changeLanguage(lang) {
      this.$i18n.locale = lang;
    }
  },
  render: h => h(App),
}).$mount('#app')
